import { getStableWidgetLocale } from '../utils/locale';
import { getScopedWidgetSession } from '../utils/widgetSessionCache';
const WARMUP_TIMEOUT_MS = 30000;
export async function hydrateDynamicWidgetText(endpoint, config, target, request) {
    if (!config.dynamicText?.enabled) {
        target.setClickReporter(null);
        return;
    }
    const inlinePrompt = config.dynamicPrompt?.prompt ?? null;
    if (inlinePrompt) {
        target.setClickReporter((selection) => {
            reportPromptClick(endpoint, {
                url: request.url,
                variantId: selection.variantId,
                locale: request.locale || getStableWidgetLocale(),
            });
        });
        return;
    }
    target.setClickReporter(null);
    if (config.dynamicPrompt && config.dynamicPrompt.source !== 'miss') {
        return;
    }
    await generatePrompt(endpoint, request);
}
async function generatePrompt(endpoint, request) {
    const client = encodeURIComponent(window.shineSettings.client);
    const chatbot = encodeURIComponent(window.shineSettings.chatbot);
    const locale = encodeURIComponent(request.locale || getStableWidgetLocale());
    const url = `${endpoint}Conversation/WidgetPrompts?client=${client}&chatbot=${chatbot}&locale=${locale}`;
    const ok = await fetchJson(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...widgetSessionHeader(),
        },
        body: JSON.stringify(request),
    }, WARMUP_TIMEOUT_MS);
    if (!ok) {
        console.warn('[shine-widget] dynamic prompt warm-up failed', {
            client: window.shineSettings.client,
            chatbot: window.shineSettings.chatbot,
        });
    }
}
function widgetSessionHeader() {
    const token = getScopedWidgetSession(window?.shineConfigs, window.shineSettings.client, window.shineSettings.chatbot, window.shineSettings);
    return token ? { 'X-Shine-Widget-Session': String(token) } : {};
}
function reportPromptClick(endpoint, payload) {
    const client = encodeURIComponent(window.shineSettings.client);
    const chatbot = encodeURIComponent(window.shineSettings.chatbot);
    const locale = encodeURIComponent(payload.locale || getStableWidgetLocale());
    const url = `${endpoint}Conversation/WidgetPrompts/Click?client=${client}&chatbot=${chatbot}&locale=${locale}`;
    const body = JSON.stringify(payload);
    const token = getScopedWidgetSession(window?.shineConfigs, window.shineSettings.client, window.shineSettings.chatbot, window.shineSettings);
    const beaconUrl = token
        ? `${url}&widgetSession=${encodeURIComponent(String(token))}`
        : url;
    try {
        if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
            const blob = new Blob([body], { type: 'application/json' });
            navigator.sendBeacon(beaconUrl, blob);
            return;
        }
    }
    catch {
        // Fall back to fetch.
    }
    void fetch(url, {
        method: 'POST',
        credentials: 'include',
        keepalive: true,
        headers: {
            'Content-Type': 'application/json',
            ...widgetSessionHeader(),
        },
        body,
    }).catch(() => undefined);
}
async function fetchJson(url, init, timeoutMs) {
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer = controller
        ? window.setTimeout(() => controller.abort(), timeoutMs)
        : null;
    try {
        const response = await fetch(url, {
            ...init,
            signal: controller?.signal,
        });
        return response.ok;
    }
    catch {
        return false;
    }
    finally {
        if (timer !== null) {
            window.clearTimeout(timer);
        }
    }
}
